import { Theme, ThemeOptions } from '@mui/material';
import material3 from '../material3';

export const getButtonOverrides = (theme: Theme): ThemeOptions['components'] => {
  return {
    MuiButton: {
      defaultProps: {
        variant: 'contained'
      },
      styleOverrides: {
        root: {
          borderRadius: material3.shape.medium,
          boxShadow: material3.elevation.level0,
          fontWeight: material3.typography.labelWeight,
          textTransform: 'none',
          ':hover': {
            boxShadow: material3.elevation.level1,
          }
        },
        outlined: {
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
          borderRadius: material3.shape.medium
        }
      }
    }
  };
};
